import React from 'react';

import AnnotationName from '../shared/AnnotationName';
import Instruction from '../shared/Instruction';
import Word from './Word';

const NamedEntityRecognition = ({ animate }) => (
  <div className="h-full rounded-lg overflow-hidden">
    <AnnotationName icon="ner" name="Named Entity Recognition" />
    <Instruction icon="label" />
    <div className="py-8 px-6 bg-white flex">
      <Arrow />
      <p className="text-base text-neutral-800 leading-10">
        They were delighted by the{' '}
        <Word color="#FE805B" type="Organization" delay={500} animate={animate}>
          Hilton&apos;s
        </Word>{' '}
        location: surrounded by vibrant nightlife, and in close proximity to major landmarks in{' '}
        <Word color="#00BFA5" type="Location" delay={1500} animate={animate}>
          Paris
        </Word>
        . And as luck would have it,{' '}
        <Word color="#FE805B" type="Person" delay={2500} animate={animate}>
          Paris Hilton
        </Word>{' '}
        happened to be staying in the room next door!
      </p>
    </div>
  </div>
);

const Arrow = () => (
  <svg className="w-6 h-6 mr-4 fill-current text-pink shrink-0" style={{ marginTop: '10px' }}>
    <path
      d="M14.4104 18.1713C14.1174 18.4646 13.6422 18.4649 13.3489 18.172C13.0556 17.879 13.0553 17.4037 13.3482 17.1104L17.7061 12.7579H4.50378C4.08957 12.7579 3.75378 12.4221 3.75378 12.0079C3.75378 11.5936 4.08957 11.2579 4.50378 11.2579H17.6934L13.3482 6.91794C13.0553 6.62464 13.0556 6.14938 13.3489 5.85643C13.6422 5.56348 14.1174 5.56376 14.4104 5.85707L20.0438 11.4838C20.3367 11.7761 20.3372 12.2506 20.0449 12.5436C20.0445 12.5439 20.0442 12.5443 20.0438 12.5447L14.4104 18.1713Z"
      fill="#ED72E2"
    />
  </svg>
);

export default NamedEntityRecognition;
